export default '$_fileUpload';
